import '@/registerServiceWorker'

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import debounce from 'debounce'
import VueLazyload from 'vue-lazyload'

// icons
import MenuIcon from '@/components/icons/MenuIcon'
import PlusIcon from '@/components/icons/PlusIcon'
import CloseIcon from '@/components/icons/CloseIcon'
import BackIcon from '@/components/icons/BackIcon'
import RecordIcon from '@/components/icons/RecordIcon'
import DotIcon from '@/components/icons/DotIcon'
import RefreshIcon from '@/components/icons/RefreshIcon'
import LocationArrow from '@/components/icons/LocationArrow'
import SearchIcon from '@/components/icons/SearchIcon'

import Modal from '@/components/Modal'
import ModalLightbox from '@/components/ModalLightbox'
import ModalLogin from '@/components/ModalLogin'
import ModalAddToHomeScreen from '@/components/ModalAddToHomeScreen'

import VueTextareaAutosize from 'vue-textarea-autosize'

Vue.component('menu-icon', MenuIcon)
Vue.component('plus-icon', PlusIcon)
Vue.component('close-icon', CloseIcon)
Vue.component('back-icon', BackIcon)
Vue.component('record-icon', RecordIcon)
Vue.component('refresh-icon', RefreshIcon)
Vue.component('location-arrow', LocationArrow)
Vue.component('search-icon', SearchIcon)
Vue.component('dot-icon', DotIcon)
Vue.component('modal', Modal)
Vue.component('modal-lightbox', ModalLightbox)
Vue.component('modal-login', ModalLogin)
Vue.component('modal-add-to-homescreen', ModalAddToHomeScreen)

Vue.use(VueTextareaAutosize)
Vue.use(VueLazyload)

Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})

Vue.mixin({
  computed: {
    isEmbed () {
      return parseInt(this.$route.query.embed) === 1
    }
  }
})

Vue.config.productionTip = false

setVH()
window.onresize = debounce(setVH, 200)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

function setVH () {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
